/* eslint-disable */
// @ts-nocheck
// source: internal/diy.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js');
goog.object.extend(proto, google_api_field_behavior_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var shared_types_decimal_pb = require('../shared/types/decimal_pb.js');
goog.object.extend(proto, shared_types_decimal_pb);
goog.exportSymbol('proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.CheckTaxYearRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.CheckTaxYearResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.CreateDiyUrlRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.CreateDiyUrlResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.ColumnTaxLinkStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.JurisdictionSubmissionStatus', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.ValueCase', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.HideDiyJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest', null, global);
goog.exportSymbol('proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.CheckTaxYearRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.CheckTaxYearRequest.displayName = 'proto.worklayer.internal.diy.v1.CheckTaxYearRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.CheckTaxYearResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.CheckTaxYearResponse.displayName = 'proto.worklayer.internal.diy.v1.CheckTaxYearResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.displayName = 'proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.displayName = 'proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.CreateDiyUrlRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.displayName = 'proto.worklayer.internal.diy.v1.CreateDiyUrlRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.CreateDiyUrlResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.displayName = 'proto.worklayer.internal.diy.v1.CreateDiyUrlResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.displayName = 'proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.displayName = 'proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.displayName = 'proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.displayName = 'proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.oneofGroups_);
};
goog.inherits(proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.displayName = 'proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.displayName = 'proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.worklayer.internal.diy.v1.HideDiyJobRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.worklayer.internal.diy.v1.HideDiyJobRequest.displayName = 'proto.worklayer.internal.diy.v1.HideDiyJobRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.CheckTaxYearRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.CheckTaxYearRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    diyJobId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearRequest}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.CheckTaxYearRequest;
  return proto.worklayer.internal.diy.v1.CheckTaxYearRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.CheckTaxYearRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearRequest}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiyJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.CheckTaxYearRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.CheckTaxYearRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiyJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string diy_job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.prototype.getDiyJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearRequest} returns this
 */
proto.worklayer.internal.diy.v1.CheckTaxYearRequest.prototype.setDiyJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.CheckTaxYearResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    currentTaxYear: jspb.Message.getFieldWithDefault(msg, 1, 0),
    diyJobTaxYear: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.CheckTaxYearResponse;
  return proto.worklayer.internal.diy.v1.CheckTaxYearResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCurrentTaxYear(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiyJobTaxYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.CheckTaxYearResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentTaxYear();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDiyJobTaxYear();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 current_tax_year = 1;
 * @return {number}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.prototype.getCurrentTaxYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse} returns this
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.prototype.setCurrentTaxYear = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 diy_job_tax_year = 2;
 * @return {number}
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.prototype.getDiyJobTaxYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.diy.v1.CheckTaxYearResponse} returns this
 */
proto.worklayer.internal.diy.v1.CheckTaxYearResponse.prototype.setDiyJobTaxYear = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    diyJobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    consultationJobId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest;
  return proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiyJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConsultationJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiyJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConsultationJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string diy_job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.prototype.getDiyJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest} returns this
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.prototype.setDiyJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string consultation_job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.prototype.getConsultationJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest} returns this
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobRequest.prototype.setConsultationJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    diyJobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse;
  return proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiyJobId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiyJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string diy_job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.getDiyJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse} returns this
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.setDiyJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse} returns this
*/
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse} returns this
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.LinkConsultationJobToDiyJobResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.CreateDiyUrlRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlRequest}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.CreateDiyUrlRequest;
  return proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.CreateDiyUrlRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlRequest}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.CreateDiyUrlRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlRequest} returns this
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, ""),
    diyJobId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    consultationJobId: (f = msg.getConsultationJobId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.CreateDiyUrlResponse;
  return proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiyJobId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConsultationJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDiyJobId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getConsultationJobId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} returns this
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string diy_job_id = 2;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.getDiyJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} returns this
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.setDiyJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue consultation_job_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.getConsultationJobId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} returns this
*/
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.setConsultationJobId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.CreateDiyUrlResponse} returns this
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.clearConsultationJobId = function() {
  return this.setConsultationJobId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.CreateDiyUrlResponse.prototype.hasConsultationJobId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest;
  return proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest} returns this
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse;
  return proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse} returns this
 */
proto.worklayer.internal.diy.v1.CheckDiyEnabledResponse.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    workspaceId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest;
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string workspace_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    currentYearDiyJob: (f = msg.getCurrentYearDiyJob()) && proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse;
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions;
      reader.readMessage(value,proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.deserializeBinaryFromReader);
      msg.setCurrentYearDiyJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrentYearDiyJob();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.ValueCase = {
  VALUE_NOT_SET: 0,
  NONE: 1,
  DIY_JOB: 2
};

/**
 * @return {proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.ValueCase}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.getValueCase = function() {
  return /** @type {proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.ValueCase} */(jspb.Message.computeOneofCase(this, proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.toObject = function(includeInstance, msg) {
  var f, obj = {
    none: (f = msg.getNone()) && google_protobuf_empty_pb.Empty.toObject(includeInstance, f),
    diyJob: (f = msg.getDiyJob()) && proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions;
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_empty_pb.Empty;
      reader.readMessage(value,google_protobuf_empty_pb.Empty.deserializeBinaryFromReader);
      msg.setNone(value);
      break;
    case 2:
      var value = new proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob;
      reader.readMessage(value,proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.deserializeBinaryFromReader);
      msg.setDiyJob(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNone();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_empty_pb.Empty.serializeBinaryToWriter
    );
  }
  f = message.getDiyJob();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Empty none = 1;
 * @return {?proto.google.protobuf.Empty}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.getNone = function() {
  return /** @type{?proto.google.protobuf.Empty} */ (
    jspb.Message.getWrapperField(this, google_protobuf_empty_pb.Empty, 1));
};


/**
 * @param {?proto.google.protobuf.Empty|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.setNone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.clearNone = function() {
  return this.setNone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.hasNone = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DiyJob diy_job = 2;
 * @return {?proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.getDiyJob = function() {
  return /** @type{?proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob, 2));
};


/**
 * @param {?proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.setDiyJob = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.clearDiyJob = function() {
  return this.setDiyJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions.prototype.hasDiyJob = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.toObject = function(includeInstance, msg) {
  var f, obj = {
    diyJobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    diyJobTaxYear: jspb.Message.getFieldWithDefault(msg, 2, 0),
    consultationJobId: (f = msg.getConsultationJobId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    federalSubmissionStatus: jspb.Message.getFieldWithDefault(msg, 4, 0),
    dateCreated: (f = msg.getDateCreated()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateUrlLastRequested: (f = msg.getDateUrlLastRequested()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && shared_types_decimal_pb.Decimal.toObject(includeInstance, f),
    hidden: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    columnTaxLinkStatus: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob;
  return proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiyJobId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiyJobTaxYear(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setConsultationJobId(value);
      break;
    case 4:
      var value = /** @type {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.JurisdictionSubmissionStatus} */ (reader.readEnum());
      msg.setFederalSubmissionStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateCreated(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateUrlLastRequested(value);
      break;
    case 7:
      var value = new shared_types_decimal_pb.Decimal;
      reader.readMessage(value,shared_types_decimal_pb.Decimal.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 9:
      var value = /** @type {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.ColumnTaxLinkStatus} */ (reader.readEnum());
      msg.setColumnTaxLinkStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiyJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDiyJobTaxYear();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getConsultationJobId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFederalSubmissionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDateCreated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateUrlLastRequested();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      shared_types_decimal_pb.Decimal.serializeBinaryToWriter
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getColumnTaxLinkStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.JurisdictionSubmissionStatus = {
  JURISDICTION_SUBMISSION_STATUS_UNSPECIFIED: 0,
  NOT_SUBMITTED: 1,
  SUBMITTED: 2,
  ACCEPTED: 3,
  RETRYABLE: 4,
  REJECTED: 5
};

/**
 * @enum {number}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.ColumnTaxLinkStatus = {
  COLUMN_TAX_LINK_STATUS_UNSPECIFIED: 0,
  LINK_NOT_STARTED: 1,
  LINK_STARTED: 2,
  LINK_SUBMITTED: 3
};

/**
 * optional string diy_job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getDiyJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setDiyJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 diy_job_tax_year = 2;
 * @return {number}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getDiyJobTaxYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setDiyJobTaxYear = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue consultation_job_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getConsultationJobId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setConsultationJobId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.clearConsultationJobId = function() {
  return this.setConsultationJobId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.hasConsultationJobId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional JurisdictionSubmissionStatus federal_submission_status = 4;
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.JurisdictionSubmissionStatus}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getFederalSubmissionStatus = function() {
  return /** @type {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.JurisdictionSubmissionStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.JurisdictionSubmissionStatus} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setFederalSubmissionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp date_created = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getDateCreated = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setDateCreated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.clearDateCreated = function() {
  return this.setDateCreated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.hasDateCreated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp date_url_last_requested = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getDateUrlLastRequested = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setDateUrlLastRequested = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.clearDateUrlLastRequested = function() {
  return this.setDateUrlLastRequested(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.hasDateUrlLastRequested = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional worklayer.shared.types.v1.Decimal price = 7;
 * @return {?proto.worklayer.shared.types.v1.Decimal}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getPrice = function() {
  return /** @type{?proto.worklayer.shared.types.v1.Decimal} */ (
    jspb.Message.getWrapperField(this, shared_types_decimal_pb.Decimal, 7));
};


/**
 * @param {?proto.worklayer.shared.types.v1.Decimal|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool hidden = 8;
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional ColumnTaxLinkStatus column_tax_link_status = 9;
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.ColumnTaxLinkStatus}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.getColumnTaxLinkStatus = function() {
  return /** @type {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.ColumnTaxLinkStatus} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.ColumnTaxLinkStatus} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJob.prototype.setColumnTaxLinkStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional DiyJobOptions current_year_diy_job = 1;
 * @return {?proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.prototype.getCurrentYearDiyJob = function() {
  return /** @type{?proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions} */ (
    jspb.Message.getWrapperField(this, proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions, 1));
};


/**
 * @param {?proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.DiyJobOptions|undefined} value
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse} returns this
*/
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.prototype.setCurrentYearDiyJob = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse} returns this
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.prototype.clearCurrentYearDiyJob = function() {
  return this.setCurrentYearDiyJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.worklayer.internal.diy.v1.GetCurrentYearDiyJobResponse.prototype.hasCurrentYearDiyJob = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.worklayer.internal.diy.v1.HideDiyJobRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.worklayer.internal.diy.v1.HideDiyJobRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    diyJobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    workspaceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.worklayer.internal.diy.v1.HideDiyJobRequest}
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.worklayer.internal.diy.v1.HideDiyJobRequest;
  return proto.worklayer.internal.diy.v1.HideDiyJobRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.worklayer.internal.diy.v1.HideDiyJobRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.worklayer.internal.diy.v1.HideDiyJobRequest}
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDiyJobId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWorkspaceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.worklayer.internal.diy.v1.HideDiyJobRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.worklayer.internal.diy.v1.HideDiyJobRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiyJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWorkspaceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string diy_job_id = 1;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.prototype.getDiyJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.HideDiyJobRequest} returns this
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.prototype.setDiyJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string workspace_id = 2;
 * @return {string}
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.prototype.getWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.worklayer.internal.diy.v1.HideDiyJobRequest} returns this
 */
proto.worklayer.internal.diy.v1.HideDiyJobRequest.prototype.setWorkspaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.worklayer.internal.diy.v1);
